<template>
    <div class="text-center">
        <div class="top-charts">

        <vue-word-cloud
                class="col-md-6 col-12 ma-auto"
                :spacing="1/2"
                style="height:480px;max-height: 480px;"
                :create-canvas="createCanvas"
                :words="wordsModel"
                :color="'Coral'"
                font-family="sofia-pro"
        >
            <template slot-scope="{text, weight, word}">

                <v-tooltip top>
                    <template v-slot:activator="{on}">
                        <div :class="textVariant?'colorful':undefined" style="cursor: pointer;" v-on="on">
                            {{ text }}
                        </div>
                    </template>
                    <div>
                        <div class="font-weight-bold text-capitalize">{{ text }}</div>
                        CTR: {{ weight }}
                    </div>
                </v-tooltip>
            </template>

        </vue-word-cloud>
        </div>
        <!--        <canvas ref="canvas" height="480" width="640"></canvas>-->
        <v-btn class="text-no-decoration" :color="textVariant?'colorful-btn':'primary'" :disabled="disableLoading" @click="loadMore()">Show more</v-btn>
    </div>
</template>
<script lang="ts">
import Component from 'vue-class-component';
import InfographicComponent from "@/components/base/InfographicComponent";
import {Prop} from "vue-property-decorator";
import {ChartData} from "@/models/general";
import {arrayToCsv, downloadAs} from "@/components/utils/utils";
import {Filters} from "@/models/Filters";
import html2canvas from "html2canvas";

  @Component({})
  export default class TopCharts extends InfographicComponent {
    @Prop() private name!: string;
    @Prop({default: null}) dataItems!: ChartData;
    @Prop() private columnHeaders!: string[];
    @Prop() private filterFirst!: number;
    @Prop(Boolean) private textVariant!: boolean;
    @Prop({type: Object, default: () => ({})}) filters!: Filters;


    wordsModel: Array<any> = new Array<any>();
    canvas: HTMLCanvasElement
    ctx: CanvasRenderingContext2D
    disableLoading: boolean = true
    loadNext:number = 0;


    mounted() {

      if (this.filterFirst) {
        this.disableLoading = false;
        this.loadMore();
      }
      else{
      this.setWordsArray(this.dataItems.datasets[0].data);
      }


      this.canvas = this.$refs.canvas as HTMLCanvasElement

    }

    download(mode: string) {
      return mode === 'csv' ? this.downloadCsv() : this.downloadImage();

    }

    createCanvas() {
      this.canvas = document.createElement('canvas');
      return this.canvas;
    };
    loadMore(){
      let data = this.dataItems.datasets[0].data;


      this.loadNext = this.filterFirst + this.loadNext;
      this.setWordsArray(data.slice(0, this.loadNext));

      if(this.loadNext >= data.length){
        this.disableLoading = true
        return;
      }

    }

    setWordsArray(dataValues:Array<any>){
      this.wordsModel = dataValues.map((item: any, index: number) => {
        return {text: this.dataItems.labels[index], weight: item }
      })
    }

    private downloadImage() {
        html2canvas(document.querySelector('.top-charts')).then((canvas) => {
            downloadAs(canvas.toDataURL(), this.name)
        });

      // this.canvas.remove()
    }

    private downloadCsv() {
      const header = [...this.columnHeaders]
      const rows = this.wordsModel.map( (word) => [word.text,word.weight] )
      rows.unshift(header)
      const timePeriod = this.filters.period.name.split(',').join(' ')
      rows.unshift([''])
      rows.unshift(['Time Period: ' + timePeriod])
      rows.unshift(['Region: ' + this.filters.region.name])
      rows.unshift(['Vertical: ' + this.filters.category.name])
      const data = rows;
      const csv = arrayToCsv(data)
      downloadAs(csv, this.name + '.csv')

    }
  }

</script>

<style scoped lang="scss">
    .top-charts {
        padding: 0 10px 0 10px;

        .colorful{
            background: -webkit-linear-gradient(45deg, rgba(69, 100, 255), $secondary-color 80%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }


    }
</style>
